import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Switcher from '../../components/Switcher'
import lang from '../../stores/lang'

const Box = styled.div`
  width: 100%;
  padding: 1rem;
`

const getValue = () => {
  if(lang.locale === 'es_US') {
    return 'SPANISH';
  } else if(lang.locale === 'ta_IN') {
    return 'TAMIL';
  }
  return 'ENGLISH';
}
@observer
export default class LanguageSwitcher extends Component {
  render() {
    return (
      <Box>
        <Switcher
          color="gray"
          title="titles.language"
          choices="language"
          value={getValue()}
          onChange={lang.set}
        />
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/LanguageSwitcher.js